import React from 'react';
import Spinner from './Spinner';

export function LoadingState() {
  return (
    <div className="flex items-center justify-center py-24" style={{ color: '#4b5563' }}>
      <Spinner className="w-5 h-5 mr-2" />
      <span className="text-sm">Loading queries…</span>
    </div>
  );
}

export function ErrorState({ message }) {
  return (
    <div className="flex flex-col items-center justify-center py-24 gap-2">
      <svg className="w-8 h-8" style={{ color: '#ef4444' }} fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v4m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
      </svg>
      <p className="text-sm" style={{ color: '#ef4444' }}>{message}</p>
    </div>
  );
}

export function EmptyState({ search }) {
  return (
    <div className="flex flex-col items-center justify-center py-24 gap-3">
      <div className="w-14 h-14 rounded-2xl flex items-center justify-center" style={{ backgroundColor: '#1e2130' }}>
        <svg className="w-7 h-7" style={{ color: '#374151' }} fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" d="M20 13V7a2 2 0 00-2-2H6a2 2 0 00-2 2v6m16 0v6a2 2 0 01-2 2H6a2 2 0 01-2-2v-6m16 0H4" />
        </svg>
      </div>
      <p className="text-sm font-medium" style={{ color: '#4b5563' }}>
        {search ? 'No queries match your search' : 'No queries yet — create one'}
      </p>
    </div>
  );
}
